export default function PlusIcon() {
  return (
    <g xmlns='http://www.w3.org/2000/svg' id='plus'>
      <path id='Vector' d='M3 8.65234H13M8 13.6523V3.65234' />
    </g>
  );
}
